import { Injectable } from '@angular/core';
import { KnowledgePanelService } from '@modules/knowledge/services/knowledge-panel.service';
import { Stitch } from '@modules/common/types/stitch';

/**
 * `KnowledgePanelService` scoped to the Dynamic Panel.
 *
 * The DP's local history mirrors the 3rd panel's marker selection (form chips and Contacts-Hub
 * facets alike). In the DP's own knowledge-panel view (no form open) it must reflect that selection,
 * and it must diverge only when the user deselects a marker there. The base service resets history
 * on every `setSelectedStitchItem` — both when a form opens and when it closes. The close reset is
 * harmful here: it would fire right after the DP re-synced its history from the parent, so returning
 * a DP form to the KP view would wipe the mirrored selection.
 *
 * Opening a form still resets (matching the main layout — a form's own knowledge section shouldn't
 * highlight the mirrored selection, and the reset stays local to the DP thanks to the reverse-pipe
 * guard in DynamicPanelComponent). Closing a form (item === null) skips the reset so the DP-local
 * history keeps mirroring the parent; the reverse-sync pipe remains the single, explicit path that
 * mirrors a genuine KP-view deselection back to the parent. See SV1-194.
 */
@Injectable()
export class DpKnowledgePanelService extends KnowledgePanelService {
  protected override resetHistoryOnSelect(item: Stitch): void {
    // Only reset when opening an item; keep the parent-mirrored filter when the form closes.
    if (item) {
      super.resetHistoryOnSelect(item);
    }
  }
}
